import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-product-temp-process',
  templateUrl: './product-temp-process.component.html',
  styleUrls: ['./product-temp-process.component.scss']
})
export class ProductTempProcessComponent {
  @Input() product: any = null;
  @Output() productChange = new EventEmitter<any>();

  products: ProductResponse[] = [];
  filterProducts: ProductResponse[] = [];
  inputs = {
    product: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  timeout = null;
  loadingExistence = false;

  constructor(
    private productService: ProductService,
    private toastService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.getProducts("");
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data
        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
    this.setProduct();
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: ProductResponse) {
    this.changeInput(this.inputs.product, product.code + " - " + product.name, true, null, "fa-circle-check", product);
  }

  setProduct() {
    if (!this.inputs.product.verified) return;

    this.product = this.inputs.product.data;
    this.productChange.emit(this.product); // <-- ESTA LÍNEA ES LA CLAVE
  }
}
